import React from 'react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';

export const WhatsAppButton: React.FC = () => {
  return (
    <FloatingWhatsApp
      phoneNumber="5511991542774"
      accountName="GZ - Atendimento"
      chatMessage="Olá! Como posso ajudar? 😊"
      statusMessage="Normalmente responde em alguns minutos"
      placeholder="Digite sua mensagem..."
      darkMode={false}
      notification
      notificationDelay={15}
      notificationSound={false}
      avatar="/logo-vazado-whatsapp.png" // Caminho direto para a logo na pasta public
    />
  );
};
